import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";

export const OfficeTableColumn = (t: TFunction<"translation", undefined>) => {
  return [
    {
      id: 1,
      key: "name",
      name: t("INVENTORY_ROOM_CONFIG.OFFICE.TABLE_COLUMN.OFFICE_NAME"),
      render: (name: any) => <Text color="subtitle1">{name}</Text>,
    },
    {
      id: 2,
      key: "address",
      name: t("INVENTORY_ROOM_CONFIG.OFFICE.TABLE_COLUMN.ADDRESS"),
      render: (address: any) => <Text color="subtitle1">{address}</Text>,
    },
  ];
};
